import { render, staticRenderFns } from "./SourceOfFundsAccordian.vue?vue&type=template&id=29dee127"
import script from "./SourceOfFundsAccordian.vue?vue&type=script&lang=js"
export * from "./SourceOfFundsAccordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports